<template>
<footer class="gbwapps-footer">
  <div class="footer-container">
    <nav class="footer-links" aria-label="Footer">
      <router-link to="/about-us/" class="footer-link">About</router-link>
      <router-link to="/contact-us/" class="footer-link">Contact</router-link>
      <router-link to="/privacy-policy/" class="footer-link">Privacy</router-link>
      <router-link to="/terms-conditions/" class="footer-link">Terms</router-link>
      <router-link to="/disclaimer/" class="footer-link">Disclaimer</router-link>
    </nav>
    <div class="footer-note">
      <p>&copy; 2026 <router-link to="/" class="footer-link">gbwapps.net</router-link> This site only shares information and guides. We are not the developer or an official partner of WhatsApp or Meta.</p>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>
